// YunEmSharpFlat.js
import React, { useEffect, useRef, useState } from 'react'
import YunIcon from '../YunIcon/YunIcon';
import YunSection from '../YunSection/YunSection';
import './YunEmSharpFlat.css';
import { openWindow } from '../../../utils/index';

const YunEmSharpFlat = function(props) {
    const { pageset, emSharpFlatState, setEmSharpFlatState } = props
    // 鼠标移上去显示说明，移开收起（不占界面空间）
    const [showTip, setShowTip] = useState(false)
    const tipTimer = useRef(null)
    useEffect(() => () => {
        // 卸载时清掉定时器
        if (tipTimer.current) clearTimeout(tipTimer.current)
    }, [])

    const showTipLater = () => {
        if (tipTimer.current) clearTimeout(tipTimer.current)
        tipTimer.current = setTimeout(() => setShowTip(true), 180)
    }
    const hideTip = () => {
        if (tipTimer.current) clearTimeout(tipTimer.current)
        setShowTip(false)
    }

    const emSharpFlatConfig = {
        min: -6,
        max: 6,
    }
    // 加减升降调值
    function clickSetSharpFlatValue(num) {
        num = emSharpFlatState.value + num
        if (num > emSharpFlatConfig.max || num < emSharpFlatConfig.min) {
            return false
        }
        setEmSharpFlatState(num)
    }

    // 跳转到电音设置页面
    function clickToSettingPage() {
        openWindow(window.location.origin + window.location.pathname + '#/em');
    }

    // 格式化升降调显示
    function getTextValue(value) {
        return value <= 0 ? value : '+' + value;
    }
    if (!pageset.emSharp) {
        return null
    }

    return (
        <div
            className="YunEmSharpFlat YunComponent"
            onMouseEnter={showTipLater}
            onMouseLeave={hideTip}
        >
            <YunSection width="200" height="33">
                <div className="YunSectionLayout">
                    <div className="Left">
                        <div className="Label MainColor4 HoverColor1 HasTip">修订调:</div>
                    </div>
                    <div className="Middle">
                        <div className="YunBtn" onClick={() => {clickSetSharpFlatValue(-1)}}>
                            <YunIcon icon="icon_sub"></YunIcon>
                        </div>
                        <span className="Value MainColor">{getTextValue(emSharpFlatState.value)}</span>
                        <div className="YunBtn" onClick={() => {clickSetSharpFlatValue(1)}}>
                            <YunIcon icon="icon_add"></YunIcon>
                        </div>
                    </div>
                    <div className="Right">
                        <p onClick={clickToSettingPage} className="SubLabel UnderlineAnimation HoverColor MainColor">电 音</p>
                    </div>
                </div>
            </YunSection>
            {showTip && (
                <div className="SharpFlatTip">
                    <div className="TipTitle">功能说明</div>
                    <div className="TipList">
                        <div className="TipItem">
                            <span className="Num">1</span>
                            <span className="Txt">
                                修订调<em>不改变</em>歌曲本身调式
                                <br />
                                只会升降电音插件
                            </span>
                        </div>
                        <div className="TipItem">
                            <span className="Num">2</span>
                            <span className="Txt">
                                专门应对副歌转调
                                <br />
                                歌曲跑调的问题
                            </span>
                        </div>
                        <div className="TipItem">
                            <span className="Num">3</span>
                            <span className="Txt">需要一定的乐理知识</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default YunEmSharpFlat;
